import React, { Component } from 'react';
import block from 'bem-cn-lite';
import connect from '../store';
import BlinkingMarker from '../../Components/BlinkingMarker';
import createCustomEvent from '../../createCustomEvent'
const b = block('Gantt_Task');

class Task extends Component {
    constructor(props) {
        super(props);
        const { offsetStart, offsetEnd, gridSizing } = this.props;
        this.onMouseDown = this.onMouseDown.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
        this.state = {
            left: offsetStart * gridSizing,
            dragged: false
        };
        this.initialOffsetStart = offsetStart;
        this.initialOffsetEnd = offsetEnd;
    }
    initialX = 0;
    actionType = 'move';
    componentDidMount() {
        this.offsetTop = this.el.offsetTop;
    }
    onMouseDown(e) {
        e.stopPropagation();
        this.setState({ isDragged: true });
        document.addEventListener('mousemove', this.onMouseMove);
        document.addEventListener('mouseup', this.onMouseUp);
        this.initialX = e.pageX / this.props.gridSizing;
        if (e.target === this.refs.leftresize) {
            this.actionType = 'left';
        } else if (e.target === this.refs.rightresize) {
            this.actionType = 'right';
        } else {
            this.actionType = 'move';
        }
    }
    onMouseMove(e) {
        e.stopPropagation();
        const {
            gridSizing,
            id,
            moveTask,
            resizeTask
        } = this.props;
        const diff = e.pageX / gridSizing - this.initialX;
        const offset = Math.round(diff);
        if (Math.abs(offset) >= 1) {
            if (this.actionType === 'left' || this.actionType === 'right') {
                resizeTask({
                    id,
                    offset,
                    direction: this.actionType
                });
            } else {
                moveTask({
                    id,
                    offset
                });
            }
            this.initialX = Math.round(e.pageX / gridSizing);
        }
    }
    onMouseUp(e) {
        e.stopPropagation();
        const { offsetStart, offsetEnd } = this.props;
        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('mouseup', this.onMouseUp);
        this.relativeX = 0;
        this.initialOffsetStart = offsetStart;
        this.initialOffsetEnd = offsetEnd;
        this.setState({ isDragged: false });
        if(this.actionType === 'move') {
            window.dispatchEvent(createCustomEvent('IS_GANTT_CHART__TASK_MOVED', { detail: { task: this.props.name } }));
        } else {
            window.dispatchEvent(createCustomEvent('IS_GANTT_CHART__TASK_RESIZED', { detail: { task: this.props.name } }));
        }
        
    }
    render() {
        const {
            name,
            dependency,
            offsetStart,
            offsetEnd,
            gridSizing,
            author,
            color
        } = this.props;
        const { isDragged } = this.state;
        let offsetToDep = false;

        const dependencyTask = this.props.getTaskById(dependency);
        if (dependencyTask) {
            offsetToDep = offsetStart - dependencyTask.offsetEnd;
        }
        return (
            <div
                className={b({ color, inProgress: isDragged })}
                onMouseDown={this.onMouseDown.bind(this)}
                ref={el => this.el = el}
                style={{
                    transform: `translate(${offsetStart * gridSizing}px, 0)`,
                    marginTop: !this.props.dependency ? '63px' : '23px',
                    width: (offsetEnd - offsetStart) * gridSizing
                }}
            >
                <div ref="leftresize" className={b('left-resize')} />
                <div ref="rightresize" className={b('right-resize')} />
                {isDragged
                    ? <div
                          className={b('sizing')}
                          style={{
                              top: `${-this.offsetTop + 19}px`
                          }}
                      />
                    : null}

                {this.props.dependency
                    ? <div
                          className={b('dependency')}
                          style={{
                              width: offsetToDep * gridSizing + 8
                          }}
                      />
                    : null}
                {this.props.tooltips.filter(tooltip => tooltip.name !== 'trial' ).length > 0
                    ? <BlinkingMarker top={2} left={2} />
                    : null}
                <div className={b('name', {saturday: (offsetEnd - 5) % 7 === 0})}>
                    <span>{name} / {author}</span>
                </div>
            </div>
        );
    }
}
export default connect(Task);
